<template>
  <div class="main">
    <!-- 轮播图 -->

    <div class="agent" v-if="type === 'china'">
      <ChinaIpGoods />
    </div>
    <div class="agent" v-else>
      <AbroadIpGoods />
    </div>

  </div>
</template>
<script>
import Pay from "./Pay.vue"
import ChinaIpGoods from "./ChinaIpGoods.vue"
import AbroadIpGoods from "./AbroadIpGoods.vue"
import { order } from '../api'
export default {
  name: 'Index',
  components: { Pay, ChinaIpGoods,AbroadIpGoods },
  data() {
    return {
      tabIndex1: 0,
      tabIndex2: 0,
      domesticTabList: ["短效动态套餐", "定制套餐"],
      tabList: ["经济型", "全面型", "企业型", "不限量"],
      activeNames: 1,
      rateList: [
        { time: 3, children: [{ rate: 20000, present: 5 }, { rate: 50000, present: 10 }] },
        { time: 10, children: [{ rate: 20000, present: 5 }, { rate: 50000, present: 10 }] }
      ],
      timeList: [
        { time: 3, present: 5 },
        { time: 5, present: 10 },
        { time: 10, present: 20 }
      ],
      chargeList: [],
      payType: 1,
      payList: [
        { name: '支付宝', icon: require('../assets/images/gmdl_zhifubao.png'), type: 'alipay' },
        { name: '微信', icon: require('../assets/images/gmdl_weixin.png'), type: 'wechat' }
      ],
      dataSouce: [],
      form: {
        goods_id: '',
        sku: {}
      },
      selectedSkuId: '',
      buyIpCount: 1,
    }
  },
  computed: {
    type() {
      return this.$route.query.type ? this.$route.query.type : 'domestic'
    },
    currentGoods() {
      return this.chargeList.find(item => item.id === this.form.goods_id) || null;
    },
    currentSku() {
      if (!this.currentGoods || !this.selectedSkuId) return null;
      return this.currentGoods.sku.find(sku => sku.sku_id === this.selectedSkuId) || null;
    }
  },
  created() {
    // this.getTabList()
    // // this.getChargeList();
    // // 默认选择第一个支付方式
    // if (this.payList && this.payList.length > 0) {
    //   this.payType = this.payList[0].type;
    // }
  },
  methods: {
    createOrder(item) {
      order.createOrder({
        goods_id: item.id,
        goods_sku_id: item.sku_id,
        paytype: this.payType
      }).then(res => {
        this.$refs.pay.onOpen(res.data.order_sn)
      })
    },
    onGoodsChange(goodsId) {
      this.form.goods_id = goodsId;
      this.form.sku = {};
      this.selectedSkuId = '';
    },
    onSkuChange() {
      if (!this.currentGoods || !this.currentGoods.sku_spec || !this.currentGoods.sku) return;
      // 1. 按 sku_spec 顺序收集所有已选 spec_value_id
      const selectedIds = this.currentGoods.sku_spec.map(spec => {
        // 找到当前选中的 value
        const selectedTitle = this.form.sku[spec.title];
        const valueObj = spec.sku_value.find(v => v.title === selectedTitle);
        return valueObj ? valueObj.id : null;
      });
      // 2. 如果有未选中的规格，直接返回
      if (selectedIds.includes(null)) {
        this.selectedSkuId = '';
        return;
      }
      const selectedKey = selectedIds.join(',');
      // 3. 匹配 sku_id
      const matchSku = this.currentGoods.sku.find(sku => sku.sku_id === selectedKey);
      if (matchSku) {
        this.selectedSkuId = matchSku.sku_id;
      } else {
        this.selectedSkuId = '';
      }
      // 规格切换后自动重置购买数量为当前SKU最小值
      if (this.currentSku && Number(this.currentSku.ip_min) > 0) {
        this.buyIpCount = Number(this.currentSku.ip_min);
      } else {
        this.buyIpCount = 1;
      }
    },
    // 获取国内的套餐
    getChargeList() {
      this.$api.goods.getChargeList().then(res => {
        this.chargeList = res.data
        // 默认选择第一个商品
        if (this.chargeList && this.chargeList.length > 0) {
          this.form.goods_id = this.chargeList[0].id;
          this.onGoodsChange(this.chargeList[0].id);
          // 默认选择规格
          const firstGoods = this.chargeList[0];
          if (firstGoods.sku_spec && firstGoods.sku_spec.length > 0) {
            this.form.sku = {};
            firstGoods.sku_spec.forEach(spec => {
              if (spec.sku_value && spec.sku_value.length > 0) {
                this.form.sku[spec.title] = spec.sku_value[0].title;
              }
            });
            this.$nextTick(() => {
              this.onSkuChange();
            });
          }
        }
      })
    },
    getTabList() {
      this.$api.goods.getCategory().then(res => {
        this.tabList = res.data
        if (this.tabList.length > 0) {
          this.getDataSouce(this.tabList[0].id)
        }
      })
    },
    getDataSouce(category_id) {
      this.$api.goods.abroadGoods({ category_id: category_id }).then(res => {
        this.dataSouce = res.data.data
      })
    },
    onTab1(index) {
      this.tabIndex1 = index
    },
    onTab2(index) {
      this.tabIndex2 = index
      this.getDataSouce(this.tabList[index].id)
    },
    // 判断面板是否处于展开状态
    isPanelActive(name) {
      return this.activeNames == name
    },
    payNow() {
      // 获取商品id和sku主键id
      const goodsId = this.form.goods_id;
      const skuId = this.currentSku ? this.currentSku.id : null;
      if (!goodsId || !skuId) {
        this.$message.error('请选择完整的商品规格');
        return;
      }

      console.log('立即支付，商品id:', goodsId, '规格sku id:', skuId, '购买数量:', this.buyIpCount);
      this.$api.order.createOrder({
        goods_id: goodsId,
        goods_sku_id: skuId,
        buy_ip_count: this.buyIpCount,
        paytype: this.payType
      }).then(res => {
        if (res.data.paystatus == 1) {
          this.$message.success('下单成功')
        } else {
          const newWindow = window.open();
          newWindow.document.write(res.data.html);
          newWindow.document.close();
        }
      })
    }
  }
}
</script>

<style scoped>
.banner {
  width: 100%;
  height: 300px;
  color: #457ff6;
  background: url(../assets/images/gmdl_bg.png) no-repeat;
}

.banner .name {
  font-size: 32px;
  text-align: center;
}

.banner p {
  margin-top: 10px;
  font-size: 16px;
}

.agent {
  padding: 20px 0;
  width: 100%;
  background: #f7f8fa;
}

.agent .box {
  margin: 0 auto;
  padding: 40px 40px 100px;
  width: 1600px;
  background: #fff;
  box-sizing: border-box;
}

.tab .item {
  width: 168px;
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  text-align: center;
  border-radius: 4px;
}

.tab .active {
  color: #fff;
  background: #2682ff;
}

.combo {
  padding-right: 50px;
  width: 196px;
  display: flex;
  flex-wrap: wrap;
}

.combo h3 {
  width: 100%;
  display: block;
  font-size: 16px;
}

.combo h3:nth-of-type(2) {
  padding-top: 10px;
  border-top: 1px solid #ccc;
}

.collapse {
  margin-top: 20px;
  width: 100%;
  border: 0;
}

.custom-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.toggle-text {
  transition: transform 0.3s ease;
  color: #606266;
}

::v-deep .el-collapse-item__arrow {
  display: none;
}

::v-deep .el-collapse-item__wrap {
  border: 0;
}

::v-deep .el-collapse-item .el-collapse-item__header {
  height: 30px;
  line-height: 30px;
  border-bottom: 0;
}

::v-deep .el-collapse-item__content {
  padding-bottom: 8px;
}

.collapse dl {
  height: 36px;
  line-height: 36px;
  font-size: 12px;
}

.collapse dl dd {
  padding: 0 10px;
  height: 20px;
  line-height: 20px;
  color: #f27729;
  font-size: 12px;
  background: #fde4dd;
  border-radius: 4px;
}



.purchase {
  padding: 0 50px;
  width: 900px;
  border-left: 1px solid #ccc;
  border-right: 1px solid #ccc;
  box-sizing: border-box;
}

.purchase h3 {
  color: #183e7c;
  font-size: 16px;
  font-weight: 600;
}

.charge {
  margin-top: 30px;
}

.charge ::v-deep .el-radio-button__inner {
  margin-right: 24px;
  padding: 30px 20px;
  color: #143b72;
  border-radius: 4px;
  border: 1px solid #eee;
  box-sizing: border-box;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.charge ::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #143b72;
  background: #e9efff;
  border: 2px solid #2682ff;
  box-shadow: 0 0 0 2px #c6e2ff;
}

.charge ::v-deep .el-radio-button__inner:hover {
  border-color: #2682ff;
}

.charge h4 {
  font-size: 16px;
}

.charge span {
  padding: 2px 10px;
  color: #143b72;
  font-size: 12px;
  border-radius: 2px;
  background: #fbf0ea;
}

.charge p {
  color: #46678a;
  font-size: 14px;
}





.order {
  margin-left: 50px;
  /* padding: 0 50px; */
  width: 280px;
}

.order h3 {
  color: #183e7c;
  font-size: 16px;
  font-weight: 600;
}

.order dl {
  height: 50px;
  line-height: 50px;
  color: #143b72;
  font-size: 14px;
}

.order dl dt {
  font-weight: 500;
}

.pay {
  border-top: 1px solid #eee;
}

.pay dt {
  color: #f3753b;
  font-size: 20px;
}

.payment {
  margin-top: 20px;
  display: flex;
}

.payment ::v-deep.el-radio-button {
  width: 100%;
  box-sizing: border-box;
}

.payment ::v-deep .el-radio-button__inner {
  padding: 8px 20px;
  width: 100%;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  border: 1px solid #eee;
  background: #fff;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.payment ::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #1a336b;
  background: #e9efff;
  border: 2px solid #2682ff;
  box-shadow: 0 0 0 2px #c6e2ff;
}

.payment ::v-deep .el-radio-button__inner:hover {
  border-color: #2682ff;
}

.pay-type {
  color: #1a336b;
}

/* .pay-type img{
    width: 24px;
    height: 24px;
} */


.pay-btn {
  width: 100%;
  color: #fff;
  background: #007bff;
}

.ip {
  width: 100%;
  height: 92px;
  line-height: 92px;
}

.ip p {
  /* width: 20%; */
  color: #183e7c;
  font-size: 14px;
}

.ip p::before {
  margin-right: 10px;
  content: "";
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 50%;
  background: #1ae206;
}

.list .item {
  position: relative;
  margin: 0 40px 40px 0;
  padding: 40px;
  width: calc(25% - 30px);
  box-sizing: border-box;
  border-radius: 8px;
  border: 1px solid #fff;
  box-shadow: 2px 2px 20px 6px #f0f1f5;
}

.list .item:hover {
  border: 1px solid #2682ff;
}

.list .name {
  width: 100%;
  color: #2682ff;
  font-size: 20px;
  text-align: center;
}

.list .money {
  padding: 4px 0;
  width: 100%;
  color: #ff7319;
  font-size: 16px;
  text-align: center;
}

.list .old-money {
  width: 100%;
  color: #999;
  font-size: 16px;
  text-align: center;
  text-decoration: line-through;
}

.list .item:nth-of-type(4n) {
  margin-right: 0;
}

.list ul {
  margin-top: 56px;
}

.list li {
  height: 36px;
  line-height: 36px;
  color: #999;
  font-size: 14px;
}

.discount {
  position: absolute;
  top: 20px;
  left: 20px;
  width: 80px;
  height: 80px;
  line-height: 80px;
  color: #000;
  font-size: 16px;
  text-align: center;
  border-radius: 50%;
  background: #d5effe;
  z-index: 10;
  /* 响应式调整 */
  display: flex;
  align-items: center;
  justify-content: center;
  word-break: break-all;
  padding: 5px;
  box-sizing: border-box;
}

/* 响应式媒体查询 */
@media screen and (max-width: 768px) {
  .discount {
    width: 60px;
    height: 60px;
    line-height: 1.2;
    font-size: 14px;
    top: 15px;
    left: 15px;
  }
}

@media screen and (max-width: 480px) {
  .discount {
    width: 50px;
    height: 50px;
    font-size: 12px;
    top: 10px;
    left: 10px;
  }
}

/* 确保折扣标签在放大时不被遮挡 */
@media screen and (min-width: 1200px) {
  .discount {
    width: 90px;
    height: 90px;
    font-size: 18px;
    top: 25px;
    left: 25px;
  }
}

.once-buy {
  margin-top: 20px;
  width: 100%;
  color: #2682ff;
  background: none;
  border: 1px solid #2682ff;
}

.list .item:hover .once-buy {
  color: #fff;
  background: #2682ff;
}

/* 特性区域 */
.features {
  padding: 100px 0;
  text-align: center;
  background: #edf2f8;
}

.features .box {
  padding: 0 100px;
  margin: 0 auto;
  width: 1600px;
  box-sizing: border-box;
}

.features h2 {
  font-size: 24px;
  margin-bottom: 4px;
}

.features p {
  margin-bottom: 10px;
  color: #999;
  font-size: 14px;
}

.feature-cards {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

.feature-card {
  margin-right: 10px;
  padding: 20px;
  flex: 0 0 calc(33.33% - 20px);
  border-radius: 4px;
  text-align: center;
  box-sizing: border-box;
}

.feature-card img {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
}

.feature-card h3 {
  font-size: 18px;
}

.feature-card p {
  margin-top: 10px;
  color: #999;
  font-size: 12px;
}

.customize p {
  line-height: 36px;
  color: #183e7c;
  font-size: 18px
}

.customize li {
  margin-right: 10px;
  padding: 6px 30px;
  color: #2682ff;
  font-size: 14px;
  border-radius: 4px;
  background: #e9efff;
  border: 1px solid #2682ff;
}

.consultative .el-button--primary {
  width: 300px;
  color: #fff;
  font-size: 14px;
  background: #2682ff;
}

.customize dl dt {
  width: 33.3333%;
  height: 36px;
  line-height: 36px;
  color: #183e7c;
  font-size: 16px;
}

.customize dl dt .el-icon-check {
  margin-right: 10px;
  color: #2682ff;
}
</style>
